exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".about .frame {\n  padding: 10px;\n}\n.about .frame img {\n  border-radius: 50%;\n  overflow: hidden;\n  display: block;\n  margin: 0 auto;\n  height: 120px;\n  transition: all 0.3s ease-in-out;\n}\n.about .frame img:hover {\n  height: 400px;\n  border-radius: 15px;\n}\n.about .caption {\n  text-align: center;\n  width: 100%;\n  display: inline-block;\n  font-style: italic;\n  color: hotpink;\n  font-size: 0.8em;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./client/app/components/about/about.less
 ** module id = 82
 ** module chunks = 0
 **/